<template>
    <v-app class="font-family-gilroy">
        <div class="desktop-main">
            <app-menu v-if="showNavbar"/>
            <router-view/>
        </div>
    </v-app>
</template>

<script>
import { isGuestRoute } from "@/router/routes.js";
import AppMenu from './components/AppMenu.vue';
import customerRatePlatform from '@/mixins/customerRatePlatform';

export default {
    mixins: [ customerRatePlatform ],

    components: {
        AppMenu,
    },

    computed: {
        showNavbar () {
            return ! isGuestRoute(this.$route.name);
        }
    }
}
</script>
